module.exports = __webpack_public_path__ + "assets/images/topo_pattern_transparent-cbf18464e0648a2be1ab709843f6ba63.svg";